import React from "react"
import Layout from '../src/Layout'

export default ({ element }) => {
  return <Layout>{element}</Layout>
}
